import { useYjsProvider } from '@liveblocks/react/_private'
import type { EditorEvents } from '@tiptap/react'
import { useCallback } from 'react'
import { handleTiptapContentError } from '#src/utils/handleTiptapContentError.ts'

export function useHandleLiveblocksTiptapContentError() {
  const yjsProvider = useYjsProvider()
  // @ts-expect-error - TODO: Remove this once Liveblocks releases an alternative. Once we're not pausing global Liveblocks syncing, let the user reload instead of calling `window.location.reload()` below.
  const pauseLiveblocksSync = yjsProvider?.pause
  return useCallback(
    (props: EditorEvents['contentError']) => {
      pauseLiveblocksSync()
      handleTiptapContentError(props)
    },
    [pauseLiveblocksSync]
  )
}
